import React from "react";
import { Layout } from "@/components/Layout";
import { InquiryForm } from "@/components/InquiryForm";
import { useContent } from "@/context/ContentContext";
import { Phone, Mail } from "lucide-react";

const fields = [
  { key: "name", label: "Your Name", required: true, placeholder: "Full name" },
  { key: "email", label: "Email Address", required: true, type: "email", placeholder: "you@email.com" },
  { key: "phone", label: "Phone Number", type: "tel", placeholder: "(000) 000-0000" },
  { key: "subject", label: "Subject", placeholder: "What is this about?" },
  { key: "message", label: "Message", required: true, type: "textarea", rows: 6, placeholder: "How can we help?" },
];

export default function Contact() {
  const c = useContent();
  const ct = c.contact || {};
  return (
    <Layout>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-14 sm:py-20">
        <span className="font-mono text-xs tracking-[0.2em] uppercase text-[#8CE63C]">We're Here to Help</span>
        <h1 className="font-display text-4xl sm:text-5xl font-black text-white uppercase tracking-tight mt-4">Contact Us</h1>

        <div className="grid lg:grid-cols-5 gap-8 mt-8">
          <div className="lg:col-span-2 space-y-4">
            <a href={`tel:${ct.phoneHref}`} data-testid="contact-phone-link" className="flex items-center gap-4 rounded-2xl border border-[#232f25] bg-[#111712] p-6 hover:border-[#8CE63C]/50 transition-colors">
              <span className="h-12 w-12 rounded-md bg-[#132717] border border-[#8CE63C]/40 flex items-center justify-center text-[#8CE63C] shrink-0">
                <Phone size={22} />
              </span>
              <div>
                <div className="font-mono text-[10px] uppercase tracking-wider text-[#69776b]">Phone</div>
                <div className="text-lg font-bold text-white">{ct.phone}</div>
              </div>
            </a>
            <a href={`mailto:${ct.email}`} data-testid="contact-email-link" className="flex items-center gap-4 rounded-2xl border border-[#232f25] bg-[#111712] p-6 hover:border-[#8CE63C]/50 transition-colors">
              <span className="h-12 w-12 rounded-md bg-[#132717] border border-[#8CE63C]/40 flex items-center justify-center text-[#8CE63C] shrink-0">
                <Mail size={22} />
              </span>
              <div>
                <div className="font-mono text-[10px] uppercase tracking-wider text-[#69776b]">Email</div>
                <div className="text-lg font-bold text-white break-all">{ct.email}</div>
              </div>
            </a>
            <p className="text-xs text-[#69776b] leading-relaxed px-1">
              {ct.note}
            </p>
          </div>

          <div className="lg:col-span-3">
            <InquiryForm
              type="Contact"
              testIdPrefix="contact"
              fields={fields}
              submitLabel="Send Message"
              thankYou={{
                title: "Message Sent!",
                body: "Thanks for contacting E Ride Power Sports. We'll get back to you as soon as possible.",
              }}
            />
          </div>
        </div>
      </div>
    </Layout>
  );
}
